import { useEffect, useState } from "react";
import apiRequest from "utils/ApiRequest/apiRequest";
import { getAvailablePickerProjectsAmount } from "components/Pages/Inbox/helpers";
import { useUser } from "contexts/userContext/userContext";

const useHasAvailableProjects = () => {
  const [projectsUsed, setProjectsUsed] = useState<number>(0);
  const [fetched, setFetched] = useState(false);

  const {
    isLoggedIn,
    getUserData,
    isSubscribed,
    isPremium,
    isPro,
    isBusiness,
  } = useUser();

  const fetchProjects = async (id: string | number) => {
    const res = await apiRequest(
      "Picker",
      `ExternalPostRequestGetProjectsList`,
      {
        UserEncryptedId: id,
      },
      "POST"
    );
    if (res.status === "success") {
      setProjectsUsed(res.data?.length || 0);
      setFetched(true);
    }
  };

  useEffect(() => {
    if (getUserData()?.UserEncryptedId) {
      fetchProjects(getUserData()?.UserEncryptedId);
    } else {
      setFetched(true);
    }
  }, [getUserData()?.UserEncryptedId]);

  const projectsAllowed = getAvailablePickerProjectsAmount(
    isPro(),
    isBusiness()
  );

  return {
    anonimus: !isLoggedIn(),
    notSubscriber: !isSubscribed(),
    premium: isPremium(),
    available: isPremium() || projectsAllowed > projectsUsed,
    fetched: fetched,
  };
};

export default useHasAvailableProjects;
